import { useState, useCallback } from "react";
import orionAPI from "../config/orionAPI";

const useSubscriptionPlans = () => {
  const [subscriptionPlans, setSubscriptionPlans] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchSubscriptionPlans = useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      const response = await orionAPI.get("api/users/me/subscription_plans");
      const plans = response.data.data;
      setSubscriptionPlans(plans);
      return plans;
    } catch (error) {
      console.error("Error fetching subscription plans:", error);
      setError(
        error.response?.data?.message ||
          "Erro ao carregar Preços de assinatura",
      );
      return [];
    } finally {
      setLoading(false);
    }
  }, []);

  const clearError = useCallback(() => {
    setError(null);
  }, []);

  return {
    subscriptionPlans,
    loading,
    error,
    fetchSubscriptionPlans,
    clearError,
  };
};

export default useSubscriptionPlans;
